import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 text-sm text-catering-ink-900 shadow-catering-xs" }
const _hoisted_2 = { class: "mb-1" }
const _hoisted_3 = { class: "divide-y divide-catering-cream-300" }
const _hoisted_4 = {
  key: 0,
  class: "tabular-nums"
}


export default {
  __name: 'BotOrderSummary',
  props: { block: { type: Object, required: true } },
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("p", { class: "mb-1 text-xs font-semibold uppercase tracking-wide text-catering-honey-600" }, "Recent orders", -1)),
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.block.count) + " recent " + _toDisplayString(__props.block.count === 1 ? 'order' : 'orders'), 1),
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.orders || [], (o, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: i,
          class: "flex justify-between py-1.5"
        }, [
          _createElementVNode("span", null, _toDisplayString(o.date), 1),
          (o.total_formatted)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(o.total_formatted), 1))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}
}

}